export default __webpack_public_path__ + "static/media/duo_with_dancers_1.a5acfcf0.jpg";